import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Зарабатывайте вместе с <Highlighted>ПолеФинанс</Highlighted>',
  text: 'Дополнительный доход без отрыва от основной работы. Привлекайте заявки на займы и получайте процент от выдач',
  button: 'Подробнее',
} satisfies TMessages
